var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid centered col-md-6"},[_c('b-card',[_c('b-card-body',[_c('label',[_vm._v(" Sie müssen "),_c('label',{staticClass:"redirect",on:{"click":_vm.redirectToLogin}},[_vm._v("eingeloggt")]),_vm._v(" sein, um diese Seite zu sehen! ")])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d70efb52","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NotLoggedIn.vue
// module id = 695
// module chunks = 2